import { type } from "@testing-library/user-event/dist/type";

export const defaultFormTemplate = {
    adminID:null,
    name:null,
    userName:null,
    email:null,
    password:"",
    newPassword:"",
    roleID:null,
    address:null,
    contactNo:null,
    whatsappNo:null,
    myTarget:null,
    dateOfBirth:null,
    company_id:null,
    created_date:null,
    lastLogin:null,
    time_zone:'Asia/Kolkata',
    status:'active',
    is_approver:'no',
    pass_update_on_reset:'no',
    photo:null,
};
export const validationRules = {
  name: { required: true, maxLength: 100,pattern: { value: /^(?! )[A-Za-z]+( [A-Za-z]+)*(?<! )$/, message: 'Special characters are not allowed.'} },
  userName: { required: true, maxLength: 100,pattern: { value: /^(?! )[A-Za-z]+( [A-Za-z]+)*(?<! )$/, message: 'Special characters are not allowed.'} },
  email:{ required: true,pattern: { value: /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z]{2,})+$/, message: 'Invalid Email.'}},
  roleID:{ required: true},
  newPassword :{required:false,pattern: { value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{6,}$/, message: 'Invalid password. Must contain 1 uppercase, 1 lowercase, 1 digit, 1 symbol, and be at least 6 characters long.'}},
  company_id:{ required: true},
  
};
// export const defaultColumns = [
//   {"fieldID":"","fieldLabel":"","fieldType":"varchar(200)","name":"adminID","linkedWith":"","fieldOptions":"","dateFormat":"","displayFormat":"","parentCategory":""},
//   {"fieldID":"","fieldLabel":"","fieldType":"varchar(200)","userName":"name","linkedWith":"","fieldOptions":"","dateFormat":"","displayFormat":"","parentCategory":""},
//   {"fieldID":"","fieldLabel":"","fieldType":"varchar(200)","email":"userName","linkedWith":"","fieldOptions":"","dateFormat":"","displayFormat":"","parentCategory":""},
// ];
export const defaultColumns = [
  {
    column_name: "adminID",
    label: "Admin ID",
    Type: "varchar(200)"
  },
  {
    column_name: "name",
    label: "Name",
    Type: "varchar(200)"
  },
  {
    column_name: "email",
    label: "Email",
    Type: "varchar(200)"
  }
];
export const columnLabels = {
  adminID: 'User ID',
  name: 'Full Name',
  userName: 'User Name',
  whatsappNo:"WhatsApp number",
  contactNo:"Contact No.",
  company_id:"Company Access",
  roleID:"User Role",
  pass_update_on_reset:"User Verification Required ",
  newPassword:"New Password",
  password:"Password",
  is_sys_user:"Is System User",
  created_by:"Created By",
  modified_by:"Modified By",
  modified_date:"Modified Date",
  created_date:"Created Date",
  };

export const  skipFields=['myTarget','password'];
export const  filterSkipFields=["myTarget",'password'];
export  const fieldOverrides = {
              roleID: {
              type: 'smartSelectInput',
              config: { label: '',type: 'role',
                source: 'user_role_master',
                valueKey:'roleID',
                placeholder: 'Select Role',
                check: 'roleName',
                getLabel: (item) => `${item.roleName}`,
                getValue: (item) => item.roleID,
                allowAddNew: false,preload: true,cache: true,showRecent: false,multi:false,
                list: 'roleName,roleID'
              }
            },
            password:{
              type:"password",
            },
            newPassword:{
              type:"password",
            },
            company_id: {
              type: 'smartSelectInput',
              config: { label: '',type: 'company',
                source: 'info_settings',
                valueKey:'infoID',
                placeholder: 'Select Company',
                check: 'companyName',
                getLabel: (item) => `${item.companyName}`,
                getValue: (item) => item.infoID,
                allowAddNew: false,preload: true,cache: true,showRecent: false,multi:true,
                list: 'companyName,infoID'
              }
            },
              status: {
                type: 'radio',
                label: 'Status',
                options: [
                    { value: 'active', label: 'Active' },
                    { value: 'inactive', label: 'In Active' }
                  ]
              },
              pass_update_on_reset: {
                type: 'radio',
                label: 'User Verification required?',
                options: [
                    { value: 'yes', label: 'Yes' },
                    { value: 'no', label: 'No' }
                  ]
              },
              time_zone: {
                type: 'dropdown',
                label: 'Default Time Zone',
                options: [
                    { value: 'Asia/Kolkata', label: 'Asia/Kolkata' },
                    { value: 'UTC', label: 'UTC' },
                    { value: 'America/New_York', label: 'US' },
                    { value: 'Europe/London', label: 'UK' },
                    { value: 'Asia/Dubai', label: 'Dubai' },
                    { value: 'Asia/Singapore', label: 'Singapore' },
                  ]
              },
              is_approver: {
                type: 'radio',
                label: 'Is Approver',
                options: [
                    { value: 'yes', label: 'Yes' },
                    { value: 'no', label: 'No' }
                  ]
                },
          };
export const directSchemaTemplate = [
  { Field: 'adminID', Type: 'int' },
  { Field: 'roleID', Type:  `int` },
  { Field: 'company_id', Type:  `varchar` },
  { Field: 'userName', Type: 'varchar' },
  { Field: 'name', Type: 'varchar' },
  { Field: 'email', Type: 'varchar' },
  { Field: 'password', Type: 'varchar' },
  { Field: 'address', Type: 'varchar' },
  { Field: 'newPassword', Type: 'varchar' },
  { Field: 'contactNo', Type: 'varchar' },
  { Field: 'whatsappNo', Type: 'varchar' },
  { Field: 'dateOfBirth', Type: 'date' },
  { Field: 'photo', Type: 'varchar' },
  { Field: 'time_zone', Type: 'varchar' },
  { Field: 'modified_by', Type: 'int' },
  { Field: 'created_by', Type: 'smartSelectInput' },
  { Field: 'created_date', Type: 'date' },
  { Field: 'modified_date', Type: 'date' },
  { Field: 'is_approver', Type: `enum(yes,no)` },
  { Field: 'status', Type: `enum(active,inactive)` },
  { Field: 'pass_update_on_reset', Type: `enum(yes,no)` },
  { Field: 'is_sys_user', Type: `enum(yes,no)` },
  
  
];
export const layout = [
    {
      label: 'Basic Info',
      row: [
        { field: 'name',colSize:'w-full mb-3 md:w-1/3' },
        { field: 'userName' ,colSize:'w-full mb-3 md:w-1/3'},
        { field: 'email'},
      ],
    },
    {
      row: [
       { field: 'password',colSize:'w-full mb-3 md:w-1/3',showWhen: {
          field: 'adminID',
          isNull: true
        }},
       { field: 'newPassword',colSize:'w-full mb-3 md:w-1/3',showWhen: {
          field: 'adminID',
          isNotNull: true
        }},
       { field: 'roleID',colSize:'w-full mb-3 md:w-1/3'},
       { field: 'company_id'},
      ]
    },
    {
      row: [
       { custom: 'contactNo',colSize:'w-full mb-3 md:w-1/3'},
       { custom: 'whatsappNo',colSize:'w-full mb-3 md:w-1/3'},
       { field: 'time_zone'},
      ]
    },
    {
      row: [
       { field: 'address',colSize:'w-full mb-3 md:w-1/3'},
       { field: 'is_approver',colSize:'w-full mb-3 md:w-1/3'},
       { field: 'status'},
      ]
    },
    {
      row: [
       { field: 'pass_update_on_reset',colSize:'w-full mb-3 md:w-1/3',showWhen: {
          isNull:true,
          field: 'adminID',
        }},
      ]
    },
    
    {
      row: [
       { addcustomFieldBtn: true },{ customFieldsPlaceholder: true }
      ]
    },
  ];
  export const infoIcons = {
    is_approver: { show: true, text: `Select "Yes" if the user should have the privilege to approve accounting records. Select "No" otherwise.` },
    pass_update_on_reset: { show: true, text: `Controls how the user receives their password \n YES: Sends a verification email so the user can set their own password.\nNO: No email sent; you manually set and share the password.` },
    
  };